import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getRecipeType = createSelector(getLiteralsState, ({ literals }) => 'Recipe Types');

export const getSchema = createSelector(getLiteralsState, ({ literals }) => literals['liquid.schema']);

export const getCountry = createSelector(getLiteralsState, ({ literals }) => literals['system.tablecountry.country']);

export const getPointSource = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.pointsource'],
);
export const getDeleted = createSelector(getLiteralsState, ({ literals }) => literals['liquid.loyaltyrule.deleted']);

export const getActive = createSelector(getLiteralsState, ({ literals }) => literals['liquid.loyaltyrule.active']);

export const getStartDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.startdate'],
);
export const getEndDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.loyaltyrule.enddate']);

export const getUpdateRecipeInfo = createSelector(getLiteralsState, ({ literals }) => 'Update Recipe');

export const getMemberCategory = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.membercategory'],
);

export const getMemberTag = createSelector(getLiteralsState, ({ literals }) => literals['liquid.loyaltyrule.tag']);

export const getDaysOfWeek = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.daysofweek'],
);

export const getDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.description'],
);

export const getId = createSelector(getLiteralsState, ({ literals }) => 'Id');

export const getCreationDate = createSelector(getLiteralsState, ({ literals }) => 'Creation Date');

export const getChangeDate = createSelector(getLiteralsState, ({ literals }) => 'Change Date');
